<script lang="ts">
import { classname } from '@/js/utils.js';

const classBaseDate = classname('base-input-date');
export default {
  name: 'BaseInputDate',
  inheritAttrs: false,
  props: {
    modelValue: {
      type: String,
      default: null,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {};
  },
  methods: {
    classBaseDate,
    emitDate() {
      this.$emit('update:modelValue', this.modelValue);
    },
  },
};
</script>

<template>
  <label :class="classBaseDate()">
    <span :class="classBaseDate('title')"><slot /></span>
    <input
      :value="modelValue"
      v-bind="$attrs"
      type="date"
      @change="emitDate"
    >
  </label>
</template>

<style lang="scss">
.base-input-date {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 10px 22px 15px 16px;
  border: 1px solid #c4c4c4;
  box-sizing: border-box;
  border-radius: 2px;

  &__title {
    margin-bottom: 3px;
    font-size: 16px;
    color: #c4c4c4;
  }

  input[type='date'] {
    font-family: inherit;
    border: none;
    outline: none;
    font-size: 18px;
    color: #000000;
  }
}
</style>
